import { format } from "date-fns";
import en from "date-fns/locale/en-US";
import ja from "date-fns/locale/ja";
import { useI18n } from "hooks/i18n/i18n";
import { useRef, useState } from "react";

import {
  calendarContainerLeftPositionStyle,
  calendarContainerRightPositionStyle,
  calendarContainerStyle,
} from "./styles";

import type { Props } from "./props";
import type { SerializedStyles } from "@emotion/core";
import type { ChangeEventHandler, MouseEventHandler } from "react";

export const useThis = (input: Props) => {
  const { position, onSelectDate, selectedDate } = input;
  const { i18n } = useI18n();
  const [showCalendar, setShowCalendar] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const formatDisplayDate = (unixTime?: number) => {
    if (!unixTime) return "";

    const isJaLocale = i18n.language === "ja";
    const formatCharacter = isJaLocale ? "yyyy年MM月dd日" : "MMM dd, yyyy";
    const locale = isJaLocale ? ja : en;
    return format(new Date(unixTime), formatCharacter, { locale });
  };

  const handleDateSelect = (date: Date | null) => {
    if (date) {
      onSelectDate(date);
    }
    setShowCalendar(false);
    inputRef.current?.focus();
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const { key } = event;
    if (key === "Backspace" || key === "Delete") {
      event.preventDefault();
      onSelectDate(null);
      setShowCalendar(false);
    }

    if (key === "Enter" && !selectedDate) {
      event.preventDefault();
      setShowCalendar(true);
    }
  };
  const handleChange: ChangeEventHandler<HTMLInputElement> = () => {
    /*
    react-datepicker のモーダルの値を入力してるため、 change handler は本来不要だが、
    develop build 時に react による runtime error が出るための対策
    keyDown でキー操作制御をしているため、 input[readonly] は有効化できない
     */
  };
  const handleShowDatepicker: MouseEventHandler = () => {
    setShowCalendar(true);
  };
  const applyCalendarContainerStyle: SerializedStyles[] = [
    calendarContainerStyle,
  ];
  if (position === "left") {
    applyCalendarContainerStyle.push(calendarContainerLeftPositionStyle);
  }
  if (position === "right") {
    applyCalendarContainerStyle.push(calendarContainerRightPositionStyle);
  }

  return {
    applyCalendarContainerStyle,
    formatDisplayDate,
    handleChange,
    handleDateSelect,
    handleKeyDown,
    handleShowDatepicker,
    inputRef,
    setShowCalendar,
    showCalendar,
  };
};
